import React from "react";
import Table from "react-bootstrap/Table";
import { useEffect } from "react";
import axios from ".././axios-interceptor";
import { useState } from "react";
import AdminNavBarMain from "./AdminNavBarMain";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import CryptoJS from 'crypto-js'
import {
  base_url,
  STATUS_NEW,
  STATUS_IN_PROGRESS,
  STATUS_APPROVED,
  STATUS_REJECTED,
  STATUS_PROCESSED,
  SERVICE_REQUEST_NEW_LOAN,
  SERVICE_REQUEST_EXTEND_TENURE,
  SERVICE_REQUEST_PRE_CLOSURE,
  STATUS_CLOSED,
  SERVICE_REQUEST_PARTIAL_PRE_PAYMENT,
  CRYPTO_SECRET_KEY,
  AUDITOR_ROLE,
  STATUS_PENDING_INVESTOR
} from "./../utilities";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";
import AdminNewLoanRequest from "./AdminNewLoanRequest";
import AdminExtendTenureRequest from "./AdminExtendTesureRequests";
import AdminPreclosureRequest from "./AdminPreclosureRequest";
import TableData from "./TableData";
import { toast } from "react-toastify";
import AdminPrePaymentRequest from "./AdminPrePaymentRequest";
import { decrypt } from "../utils";
import Cookies from 'js-cookie';

const AllServiceRequests = (props) => {
  let ltwo = props.loading;
  const navigate = useNavigate();
  const [serviceRequests, setServiceRequests] = useState([]);
  const [download, setDownload] = useState([]);
  const [serviceRequestsfilter, setServiceRequestsFilter] = useState([]);
  const [selectedobject, setServiceObject] = useState([]);
  const [modalShow, setModalShow] = React.useState(false);
  const [modalShowExtendTenure, setModalShowEntendTenure] =
    React.useState(false);
  const [modalShowPreclosure, setModalShowPreclosure] = React.useState(false);
  const [modalShowPartialPayment, setModalShowPartialPayment] = React.useState(false);
  const [adminServicerequestsCounts, setAdminServicerequestsCounts] = useState([]);
  const [defaultvalue, setDefaultValue] = useState(false)
  const [loading, setLoading] = useState(true);
  const [totalpending, setTotalPending] = useState("");
  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });

  let count = serviceRequestsfilter.length;

  const columns = [
    {
      title: "Business Name",
      field: "business_name",
      sort: (a, b) => a.business_name.localeCompare(b.business_name),
    },
    {
      title: "Request Type",
      field: "service_type_name",
      sort: (a, b) => a.service_type_name.localeCompare(b.service_type_name),
    },
    {
      title: "Service Request Ref No.",
      field: "service_request_reference_no",
      sort: (a, b) =>
        a.service_request_reference_no.localeCompare(
          b.service_request_reference_no
        ),
    },
    {
      title: "Loan Amount",
      field: "loan_amount",
      currency: "admin_request_loan_currency",
      sort: (a, b) => parseFloat(a.status) - parseFloat(b.status),
    },
    { title: "Status", field: "status" },
    {
      title: "Last Activity",
      field: "updated_date_time_number",
      sort: (a, b) => parseFloat(a.status) - parseFloat(b.status),
    },
    {
      title: "Actions",
      filed: "image",
      type: "eye",
      image: "./images/icons/blue_eye.svg",
    },
  ];
const[displayedData,setDisplayedData]=useState([]);
  const handleChangeAllInput=(e)=>{
    const value = e.target.value;
if(value.length>2)
{
  axios
      .post(base_url+'service-request-trx/get_all_service_requests_admin',{filter_value:value})
      .then((res)=>{
        let data=res.data.data;
        if (data && data.length > 0) {
          setServiceRequestsFilter(data);
          setFirstValue(data);
          setSecondValue(data);
          setThirdValue(data);
          setFourthValue(data);
          setFifthValue(data);
        }
      })
      .catch((err)=>{
        console.log(err,"error");
      })
}
if(value.length===0)
{
  setServiceRequestsFilter(displayedData);
}
  }

  const goToAdminDashboard = () => {
    navigate("/admindashboard");
  };
  useEffect(() => {
    if (!Cookies.get("User_Accesstoken_Admin")) {
      navigate("/adminlogin");
    }
    setTimeout(() => {
      axios
        .post(base_url + "service-request-trx/get_service_requests_count")
        .then((res) => {
          let data = res.data.data;
          setAdminServicerequestsCounts(data);

          setTotalPending(data.pending + data.new + data.approved);
        });
      axios
        .post(base_url + "service-request-trx/get_all_service_requests_admin")
        .then((res) => {
          res.data.data.forEach((elem) => {
            elem.updated_date_time_number = elem.updated_date_time;
            elem.updated_date_time = moment(elem.updated_date_time).format(
              "D MMM YYYY H:mm"
            );

            if (elem.status === STATUS_NEW) {
              elem.status = "New";
            }
            if (elem.status === STATUS_IN_PROGRESS) {
              elem.status = "In Progress";
            }
            if (elem.status === STATUS_PROCESSED) {
              elem.status = "Processed";
            }
            if (elem.status === STATUS_REJECTED) {
              elem.status = "Rejected";
            }
            if (elem.status === STATUS_APPROVED) {
              elem.status = "Approved";
            }
            if (elem.status === STATUS_CLOSED) {
              elem.status = "Closed";
            }
            if (elem.status === STATUS_PENDING_INVESTOR) { elem.status = "Pending Investor Approval"; }
            if (elem.service_type_code === SERVICE_REQUEST_NEW_LOAN) {
              elem.service_type_name = "New Loan";
            }
            if (elem.service_type_code === SERVICE_REQUEST_EXTEND_TENURE) {
              elem.service_type_name = "Extend Tenure";
            }
            if (elem.service_type_code === SERVICE_REQUEST_PRE_CLOSURE) {
              elem.service_type_name = "Pre-Closure";
            }
            if (elem.service_type_code === SERVICE_REQUEST_PARTIAL_PRE_PAYMENT) {
              elem.service_type_name = "Partial Prepayment";
            }
          });
          let data = res.data.data;
          setServiceRequests(data);
          setServiceRequestsFilter(data);
          setFirstValue(data);
          setSecondValue(data);
          setThirdValue(data);
          setFourthValue(data);
          setFifthValue(data);
          setDisplayedData(data);
          if (data !== "" || data !== undefined) {
            setLoading(false);
          }
          setDownload(data);
        })
        .catch((err) => {
          if (err.response.statusText == "Unauthorized") {
            toast.error("Your session has expired. Please login again", {
              toastId: 7,
            });
            Cookies.remove("User_Accesstoken_Admin");
            Cookies.remove("User_Refreshtoken_Admin");
            navigate("/adminlogin");
          }
        });
    }, 100);
  }, []);

  const handleData = (data) => {
    if (
      data.status === "New" &&
      data.service_type_code === SERVICE_REQUEST_NEW_LOAN
    ) {
      setModalShow(true);
    }
    if (
      data.status === "New" &&
      data.service_type_code === SERVICE_REQUEST_EXTEND_TENURE
    ) {
      setModalShowEntendTenure(true);
    }
    if (
      data.status === "New" &&
      data.service_type_code === SERVICE_REQUEST_PRE_CLOSURE
    ) {
      setModalShowPreclosure(true);
    }
    if (
      data.status === "New" &&
      data.service_type_code === SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      setModalShowPartialPayment(true);
    }
    setServiceObject(data);
  };

  const [firstValue, setFirstValue] = useState([]);
  const [secondValue, setSecondValue] = useState([]);
  const [thirdValue, setThirdValue] = useState([]);
  const [fourthValue, setFourthValue] = useState([]);
  const [fifthValue, setFifthValue] = useState([]);

  const [initialValue, setInitialValue] = useState('')
  const [secondFilterValue, setSecondFilterValue] = useState('')
  const [thirdFilterValue, setThirdFilterValue] = useState('')
  const [fourthFilterValue, setFourthFilterValue] = useState('')
  const [fifthFilterValue, setFifthFilterValue] = useState('')

  const handleChangeInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (name === "business" && secondFilterValue ==='' && thirdFilterValue==='' && fourthFilterValue===''&& fifthFilterValue==='') {
      setInitialValue("business")
      let f = firstValue.filter((item) => {
        if (value === item.business_name) {
          return item;
        }
        if (value === "All") {
          setInitialValue("")
          
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setSecondValue(f);
      setThirdValue(f);
      setFourthValue(f);
      setFifthValue(f);
    }
    if (name === "business" && secondFilterValue !=='' && fifthFilterValue !=='') {
      let f = firstValue.filter((item) => {
        if (value === item.business_name) {
          return item;
        }
        if (value === "All") {
          setInitialValue("")
          
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setThirdValue(f);
      setFourthValue(f);
    }
    if (name === "business" && fifthFilterValue !=='') {
      setInitialValue("business")
      let f = firstValue.filter((item) => {
        if (value === item.business_name) {
          return item;
        }
        if (value === "All") {
          setInitialValue("")
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setSecondValue(f);
      setThirdValue(f);
      setFourthValue(f);
    }

    if (name === "req" && initialValue ==='' && thirdFilterValue==='' && fourthFilterValue===''&& fifthFilterValue==='') {
      setSecondFilterValue("req")
      let f = secondValue.filter((item) => {
        if (value === item.service_type_name) {
          return item;
        }
        if (value === "All") {
          setSecondFilterValue("")
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setFirstValue(f);
      setThirdValue(f);
      setFourthValue(f);
      setFifthValue(f);
    }
    if (name === "req" && initialValue !=='' && fifthFilterValue ==='') {
      setSecondFilterValue("req")
      let f = secondValue.filter((item) => {
        if (value === item.service_type_name) {
          return item;
        }
        if (value === "All") {
          setSecondFilterValue("")
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setThirdValue(f);
      setFourthValue(f);
      setFifthValue(f);
    }
    if (name === "req" && initialValue !=='' && fifthFilterValue !=='') {
      setSecondFilterValue("req")
      let f = secondValue.filter((item) => {
        if (value === item.service_type_name) {
          return item;
        }
        if (value === "All") {
          setSecondFilterValue("")
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setThirdValue(f);
      setFourthValue(f);
    }
    if (name === "req" && fifthFilterValue !=='' ) {
      setSecondFilterValue("req")
      let f = secondValue.filter((item) => {
        if (value === item.service_type_name) {
          return item;
        }
        if (value === "All") {
          setSecondFilterValue("")
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setThirdValue(f);
      setFirstValue(f)
      setFourthValue(f);
    }
    if (name === "service" && initialValue ==='' && secondFilterValue==='' && fourthFilterValue===''&& fifthFilterValue==='') {
      setThirdFilterValue("service")
      let f = thirdValue.filter((item) => {
        if (value === item.service_request_reference_no) {
          return item;
        }
        if (value === "All") {
          setThirdFilterValue("")
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setSecondValue(f);
      setFirstValue(f);
      setFourthValue(f);
      setFifthValue(f);
    }
    if (name === "service" && initialValue !=='' && secondFilterValue!=='' && fifthFilterValue!=='') {
      let f = thirdValue.filter((item) => {
        if (value === item.service_request_reference_no) {
          return item;
        }
        if (value === "All") {
          setThirdFilterValue("")
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setFourthValue(f);
    }
    if (name === "service" && secondFilterValue !=='' && fifthFilterValue !=='') {
      let f = thirdValue.filter((item) => {
        if (value === item.service_request_reference_no) {
          return item;
        }
        if (value === "All") {
          setThirdFilterValue("")
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setFourthValue(f);
      setFirstValue(f);
    }
    if (name === "service" && initialValue !=='' && secondFilterValue !=='' ) {
      let f = thirdValue.filter((item) => {
        if (value === item.service_request_reference_no) {
          return item;
        }
        if (value === "All") {
          setThirdFilterValue("")
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setFourthValue(f);
      setFifthValue(f);
    }
    if (name === "service" && fourthFilterValue !=='' && fifthFilterValue !=='' ) {
      let f = thirdValue.filter((item) => {
        if (value === item.service_request_reference_no) {
          return item;
        }
        if (value === "All") {
          setThirdFilterValue("")
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setSecondValue(f)
      setFirstValue(f);

    }
    if (name === "service" && initialValue !=='' && fifthFilterValue !=='' ) {
      let f = thirdValue.filter((item) => {
        if (value === item.service_request_reference_no) {
          return item;
        }
        if (value === "All") {
          setThirdFilterValue("")
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setSecondValue(f)
      setFourthValue(f);

    }
    if (name === "service" && fifthFilterValue !=='' ) {
      let f = thirdValue.filter((item) => {
        if (value === item.service_request_reference_no) {
          return item;
        }
        if (value === "All") {
          setThirdFilterValue("")
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setFirstValue(f)
      setSecondValue(f)
      setFourthValue(f);

    }
    if (name === "investment" && initialValue ==='' && secondFilterValue==='' && thirdFilterValue===''&& fifthFilterValue==='') {
      setFourthFilterValue("investment")
      let startRange = value.split("-")[0];
      let endRange = value.split("-")[1];
      let f = fourthValue.filter((item) => {
        let loanamount = Number(item.loan_amount);
        let initialAmount = Number(startRange);
        let finalAmount = Number(endRange);
        
        if (loanamount >= initialAmount && item.loan_amount <= finalAmount) {
          return item;
        }
        
        if (value === "All") {
          setFourthFilterValue("")
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setSecondValue(f);
      setThirdValue(f);
      setFirstValue(f);
      setFifthValue(f);
    }
    if (name === "investment" &&  fifthFilterValue!=='') {
      setFourthFilterValue("investment")
      let startRange = value.split("-")[0];
      let endRange = value.split("-")[1];
      let f = fourthValue.filter((item) => {
        let loanamount = Number(item.loan_amount);
        let initialAmount = Number(startRange);
        let finalAmount = Number(endRange);
        
        if (loanamount >= initialAmount && item.loan_amount <= finalAmount) {
          return item;
        }
        
        if (value === "All") {
          setFourthFilterValue("")
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setSecondValue(f);
      setThirdValue(f);
      setFirstValue(f);
    }
    if (name === "status" && initialValue ==='' && secondFilterValue==='' && thirdFilterValue==='' && fourthFilterValue ==='') {

      setFifthFilterValue("status")
      let f = fifthValue.filter((item) => {
        if (value === item.status) {
          return item;
        }
        if (value === "All") {
          setFifthFilterValue("")
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setSecondValue(f);
      setThirdValue(f);
      setFourthValue(f);
      setFirstValue(f);
    }
    if (name === "status" && secondFilterValue!=='') {

      setFifthFilterValue("status")
      let f = fifthValue.filter((item) => {
        if (value === item.status) {
          return item;
        }
        if (value === "All") {
          setFifthFilterValue("")
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setThirdValue(f);
      setFourthValue(f);
      setFirstValue(f);
    }
    if (name === "status" && fourthFilterValue !=='') {

      setFifthFilterValue("status")
      let f = fifthValue.filter((item) => {
        if (value === item.status) {
          return item;
        }
        if (value === "All") {
          setFifthFilterValue("")
          return item;
        }
      });
      setServiceRequestsFilter(f);
      setSecondValue(f)
      setThirdValue(f);
      setFirstValue(f);
    }
    setDefaultValue(false);
  };

  const uniqueBusiness = [...new Set(firstValue.map((d) => d.business_name))];
  const uniqueReq = [...new Set(secondValue.map((d) => d.service_type_name))];
  const uniqueService = [
    ...new Set(thirdValue.map((d) => d.service_request_reference_no)),
  ];
  const uniqueInvestment = [...new Set(fourthValue.map((d) => d.loan_amount))];
  const uniqueStatus = [...new Set(fifthValue.map((d) => d.status))];

  function exportToExcel() {
    let sample_data_array = [];
    serviceRequestsfilter.forEach((elem) => {
      if (elem.admin_request_loan_currency === "USD") {
        elem.admin_request_loan_currency = "$";
      }
      let xl_object = {
        "Service Request Ref No.": elem.service_request_reference_no,
        "Business Name": elem.business_name,
        "Request Type": elem.service_type_name,
        "Loan Amount": elem.admin_request_loan_currency + " " + elem.loan_amount,
        Status: elem.status,
        "Last Activity": elem.updated_date_time,
      };
      sample_data_array.push(xl_object);
    });
    // create the data that you want to write to the excel file
    const data = sample_data_array;

    // create a worksheet and add the data to it
    const worksheet = XLSX.utils.json_to_sheet(data);

    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = "service_requests.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
  }
  const clearFilters = () => {
    setServiceRequestsFilter(serviceRequests);
    setDefaultValue(true);
    setFirstValue(serviceRequests);
    setSecondValue(serviceRequests);
    setThirdValue(serviceRequests);
    setFourthValue(serviceRequests);
    setFifthValue(serviceRequests);
    setInitialValue('')
    setSecondFilterValue('')
    setThirdFilterValue('')
    setFourthFilterValue('')
    setFifthFilterValue('')
  };

  const handleSort = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });

    const sortedData = [...serviceRequestsfilter].sort((a, b) => {
      const columnA = column == "loan_amount" ? parseInt(a[column]) : a[column];
      const columnB = column == "loan_amount" ? parseInt(b[column]) : b[column];

      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setServiceRequestsFilter(sortedData);
  };

  const [role_code,setRoleCode]=useState(Cookies.get("role_code"));

  useEffect(()=>{
    if(role_code){
      const decryptedValueData = decrypt(role_code)
      setRoleCode(decryptedValueData);
    }
  },[])
  return (
    <div className="">
      <AdminNavBarMain />
      <div className="row admin_body_main bg-transparent mt-1">
        <div className="d-flex justify-content-between">
          <div className="col d-flex justify-content-between">
            <h5
              className="admin_serv mb-2"
              onClick={() => goToAdminDashboard(true)}
            >
              <img
                src="./images/left_arrow.svg"
                alt=""
                className="indiv_loan_dtls "
              />
              &nbsp; Service Requests
            </h5>
          </div>
        </div>
        <div className="container p-0">
          <div className="row d-flex justify-content-between">
            <div className="col-md-2 mb-3 mb-md-0  ">
              <div className=" b_style_new ms-0 ms-md-1">
                <span> No. of Requests</span>
                <p className="p_style">{adminServicerequestsCounts.total}</p>
              </div>
            </div>
            <div className="col-md-2 mb-3 mb-md-0">
              <div className=" n_style_new">
                <span>Total Resolved</span>
                <p className="p_style">
                  {adminServicerequestsCounts.processed}
                </p>
              </div>
            </div>
            <div className="col-md-2 mb-3 mb-md-0">
              <div className=" p_style_new">
                <span> Total Pending</span>
                <p className="p_style">{totalpending}</p>
              </div>
            </div>
            <div className="col-md-2 mb-3 mb-md-0">
              <div className=" r_style_new">
                <span> Total Rejected</span>
                <p className="p_style">{adminServicerequestsCounts.rejected}</p>
              </div>
            </div>
            <div className="col-md-2">
              <input
              id="all"
              name="all"
              type="text"
              className="form-control rounded px-4 py-3 border-0 w-100"
              placeholder="Search by keywords"
              onChange={(e)=>handleChangeAllInput(e)}
              />
            </div>
            <div className="col text-end">
              <div className=" count_of_records_ALLSR">
                <span>No.of Records : {count}</span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="row mb-2 mt-2 gap-3">
            <div className="col">
              <label htmlFor="business" className="form-label">
                <p>Search by Business</p>
              </label>
              <select
                id="business"
                className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                aria-label="form-select example"
                name="business"
                autoComplete="off"
                onChange={handleChangeInput}
              >
                <option selected={defaultvalue}>All</option>

                {uniqueBusiness.map((type) => {
                  return <option key={type}>{type}</option>;
                })}
              </select>
            </div>
            <div className="col">
              <label htmlFor="req" className="form-label">
                <p>Request Type</p>
              </label>
              <select
                id="req"
                className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                aria-label="form-select example"
                name="req"
                autoComplete="off"
                onChange={handleChangeInput}
              >
                <option selected={defaultvalue}>All</option>

                {uniqueReq.map((type) => {
                  return <option key={type}>{type}</option>;
                })}
              </select>
            </div>

            <div className="col-lg">
              <label htmlFor="service" className="form-label">
                <p>Service Ref No.</p>
              </label>
              <select
                id="service"
                className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                aria-label="form-select example"
                name="service"
                autoComplete="off"
                onChange={handleChangeInput}
              >
                <option selected={defaultvalue}>All</option>

                {uniqueService.map((type) => {
                  return <option key={type}>{type}</option>;
                })}
              </select>
            </div>

            <div className="col-lg">
              <label htmlFor="investment" className="form-label">
                <p>Loan Amount</p>
              </label>
              <select
                className="form-select  dropdn_select_cls shadow-ben APNL_option_flds"
                id="investment"
                onChange={handleChangeInput}
                name="investment"
              >
                <option selected={defaultvalue}>All</option>
                <option value="1000-5000">1000 - 5000</option>
                <option value="5001-10000">5001 - 10000</option>
                <option value="10001-50000">10001 - 50000</option>
                <option value="50001-100000">50001 - 100000</option>
                <option value="100001-250000">100001 - 250000</option>
                <option value="250001-500000">250001 - 500000</option>
              </select>
            </div>

            <div className="col-lg-1">
              <label htmlFor="status" className="form-label">
                <p>Status</p>
              </label>
              <select
                id="status"
                className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                aria-label="form-select example"
                name="status"
                autoComplete="off"
                onChange={handleChangeInput}
              >
                <option selected={defaultvalue}>All</option>
                {uniqueStatus.map((type) => {
                  return <option key={type}>{type}</option>;
                })}
              </select>
            </div>
            <div className=" col align-self-end">
              <button className="blue_btn" onClick={clearFilters}>
                Clear All Filters
              </button>
            </div>

            <div className="col btn_style">
              <button
                className="blue_btn "
                onClick={exportToExcel}
                disabled={role_code===AUDITOR_ROLE}
              >
                Download XLS
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="px-5">
        <div className=" allservicereq_tab_styl">
          <Table
            striped
            //  bordered
            className="  text-center "
          >
            <TableData
              handleSort={handleSort}
              ltwo={ltwo}
              loading={loading}
              data={serviceRequestsfilter}
              columns={columns}
              onImageClick={handleData}
            />
          </Table>
              <AdminNewLoanRequest
                data={selectedobject}
                show={modalShow}
                onHide={() => setModalShow(false)}
                role_code={role_code}
              />
              <AdminExtendTenureRequest
                data={selectedobject}
                show={modalShowExtendTenure}
                onHide={() => setModalShowEntendTenure(false)}
              />
              <AdminPreclosureRequest
                data={selectedobject}
                show={modalShowPreclosure}
                onHide={() => setModalShowPreclosure(false)}
              />
              <AdminPrePaymentRequest
                data={selectedobject}
                show={modalShowPartialPayment}
                onHide={() => setModalShowPartialPayment(false)}
              />
        </div>
      </div>
    </div>
  );
};

export default AllServiceRequests;
